import { render, staticRenderFns } from "./ChartPetugas.vue?vue&type=template&id=5d4afd20&"
import script from "./ChartPetugas.vue?vue&type=script&lang=js&"
export * from "./ChartPetugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports